<template>
  <div
    class="query-filter-element"
    @mouseenter="active = true"
    @mouseleave="active = false"
  >
    <md-card class="elevationClass" :class="{ 'disable-input': disabled }">
      <md-card-header>
        <div :id="id" class="md-title animated">
          {{ title }}
        </div>
      </md-card-header>
      <md-card-content :style="contentStyles">
        <slot></slot>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
/**
 * 分析条件汎用コンポーネント
 */
export default {
  props: {
    /**
     * 分析条件に指定するタイトル
     */
    title: String,
    /**
     * 分析条件サマリクリックにより縦スクロールするためのID
     */
    id: {
      type: String,
      required: true,
    },
    contentWidth: {
      type: String,
      default: 'full',
      validator(v) {
        return ['small', 'medium', 'large', 'full'].includes(v)
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    elevationClass() {
      return {
        'md-elevation-4': !this.active,
        'md-elevation-20': this.active,
      }
    },
    /**
     * パネル内コンテンツのスタイル
     */
    contentStyles() {
      let width

      switch (this.contentWidth) {
        case 'small':
          width = 300
          break
        case 'medium':
          width = 500
          break
        case 'large':
          width = 900
          break
      }

      return {
        width: width ? `${width}px` : '100%',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.query-filter-container {
  padding-left: var(--spacing-medium);
  padding-right: var(--spacing-medium);
}

.md-card {
  transition: box-shadow 150ms ease-out;
}

.header {
  font-size: var(--font-size-xlarge);
  margin-top: var(--spacing-large);
  margin-bottom: var(--spacing-large);
}

.disable-input {
  background-color: #c0c0c0;
  opacity: 0.5;
  pointer-events: none;
}
</style>
